import { Typography } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const BookmakerField = ({ record, source, basePath, ...props }) => {
	const translate = useTranslate();
	return (
		<Typography {...props}>
			{get(
				record,
				source,
				translate("resources.bookmaker-deals.fields.bookmaker.all")
			)}
		</Typography>
	);
};
export default BookmakerField;
